<template>
  <div>
    <el-button v-bind="$attrs" v-on="$listeners" @click="onClick">
      <slot></slot>
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'ShDelButton',
  props: {
    message: {
      type: String,
      default: '确定删除吗？'
    },
    delTipsShow: {
      type: Boolean,
      default: true
    },
    canceTipsShow: {
      type: Boolean,
      default: false
    },
    confirmOptions: {
      type: Object,
      default: () => {
        return {
          title: '提示',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      }
    },
    delTipsOptions: {
      type: Object,
      default: () => {
        return {
          message: '删除成功',
          type: 'success'
        }
      }
    },
    cancelTipsOptions: {
      type: Object,
      default: () => {
        return {
          message: '已取消删除',
          type: 'info'
        }
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    onClick() {
      // this.$confirm(this.confirmOptions.message, this.confirmOptions.title, {
      //   confirmButtonText: this.confirmButtonText,
      //   cancelButtonText: this.cancelButtonText,
      //   type: this.confirmOptions.type
      // })
      this.$confirm(this.message, this.confirmOptions)
        .then(() => {
          if (this.delTipsShow) {
            this.$message({
              type: this.delTipsOptions.type || 'success',
              message: this.delTipsOptions.message || '删除成功'
            })
          }
          this.$emit('confirm')
        })
        .catch(() => {
          if (this.showMessage) {
            this.$message({
              type: this.cancelTipsOptions.type || 'info',
              message: this.cancelTipsOptions.message || '已取消删除'
            })
          }
          this.$emit('cancel')
        })
    }
  }
}
</script>

<style lang="scss"></style>
